import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./assets/css/styles.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import axios from "axios";
import { getLocalStorageItem } from "./utils/localStorage";
// import { ErrorBoundary } from "react-error-boundary";
// import ErrorPage from "./Components/ErrorPage";
import { decryptResponse, encryptRequest } from "./utils/encryption";
import * as toast from './utils/makeToast'


// THE LINE BELOW DISABLES CONSOLE LOG
console.log = () => { };



axios.interceptors.request.use((request: any) => {
  let token = getLocalStorageItem("accessToken");

  request.headers!.Accept = "application/json; charset=utf-8"
  request.headers!["Content-Type"] = "application/json; charset=utf-8"

  request.headers!['Cache-Control'] = "no-store"
  request.headers!.Pragma = "no-cache"

  if (getLocalStorageItem("accessToken")) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  console.log(request.data)
  request.data = encryptRequest(request.data)
  

  return request

});

axios.interceptors.response.use(
  function (res) {
    return { ...res, data: decryptResponse(res.data) }
  },
  function (error) {
    if (error?.response?.data) {
      let decryptedResponse = decryptResponse(error?.response?.data)?.message
      if (decryptedResponse) {
        toast.errorToast(decryptedResponse)
      }
    }
    return Promise.reject(decryptResponse(error));
    // return Promise.reject(error);
  }
);


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(

  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
  // </ErrorBoundary>
);

reportWebVitals();

// function ErrorFallback({ error, resetErrorBoundary }: any) {
//   return (
//     <div>
//       <ErrorPage />
//     </div>
//   );
// }